<h2 mat-dialog-title class="sas__title" autoTranslate>Iniciar turno</h2>

<mat-dialog-content class="sas__content">
    <p class="sas__lead" *ngIf="!data.forceCrewMode">
        <ng-container autoTranslate>O clique foi na função</ng-container>
        <strong> {{ data.roleLabel }}</strong>.
        <span autoTranslate>Este turno é só para essa função ou inclui outras?</span>
    </p>

    <div class="sas__options" *ngIf="!data.forceCrewMode">
        <button
            type="button"
            class="sas__option"
            [class.sas__option--active]="scope === 'role'"
            (click)="selectScope('role')"
        >
            <span class="sas__option-title" autoTranslate>Só esta função</span>
            <span class="sas__option-desc">
                <ng-container autoTranslate>Iniciar o turno apenas para</ng-container>
                {{ data.roleLabel }}.
            </span>
        </button>
        <button
            type="button"
            class="sas__option"
            [class.sas__option--active]="scope === 'crew'"
            (click)="selectScope('crew')"
        >
            <span class="sas__option-title" autoTranslate>Incluir outras funções</span>
            <span class="sas__option-desc" autoTranslate>
                Selecionar vários profissionais e gerar uma alocação para todos.
            </span>
        </button>
    </div>

    <div class="sas__crew" *ngIf="scope === 'crew'">
        <p class="sas__crew-lead" autoTranslate>Marque os profissionais deste turno:</p>
        <section class="sas__group" *ngFor="let group of groups">
            <h3 class="sas__group-title">{{ group.label | autoTranslate }}</h3>
            <label class="sas__person" *ngFor="let user of group.users">
                <mat-checkbox [(ngModel)]="user.selected"></mat-checkbox>
                <span class="sas__person-name">{{ user.name }}</span>
            </label>
        </section>
        <p class="sas__empty" *ngIf="!groups.length" autoTranslate>Nenhum profissional disponível.</p>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="sas__actions">
    <button mat-stroked-button type="button" (click)="cancel()">
        <span autoTranslate>Cancelar</span>
    </button>
    <button mat-flat-button color="primary" type="button" [disabled]="!canContinue" (click)="submit()">
        <span autoTranslate>Continuar</span>
    </button>
</mat-dialog-actions>
